import React from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import { Row } from "react-flexbox-grid";
import {
  CircularProgress,
  Card,
  Switch,
  FormControlLabel,
  Tooltip
} from "@material-ui/core";

const styles = {
  dropzone: {
    height: 400,
    marginTop: 20,
    marginBottom: 20,
    borderStyle: "dashed",
    textAlign: "center",
    borderRadius: 2
  },
  dropzoneText: {
    height: "100%",
    fontSize: 28,
    color: "gray",
    fontFamily: "roboto"
  },
  active: {
    borderStyle: "solid"
  },
  filedrop: {
    padding: 20
  }
};

const FileDropCard = props => (
  <Card style={styles.filedrop}>
    <Tooltip
      title={`If a mistake is made when uploading a file, it can be re-uploaded with the same filename to be overwritten.
        This will roll back annotations and processing for that file as well.`}
      enterDelay={700}
      leaveDelay={200}
    >
      <Dropzone
        onDrop={props.onFilesDrop}
        style={styles.dropzone}
        activeStyle={styles.active}
      >
        <Row center="xs" middle="xs" style={styles.dropzoneText}>
          {props.filesUploading ? (
            <CircularProgress color="primary" />
          ) : (
            <div>
              <div>
                Drop Seabird CTD <small>(.hex)</small>
              </div>
              <div>
                and RBR CTD <small>(eng.txt & .rsk/.hex)</small>
              </div>
              <div>files here to upload them.</div>
            </div>
          )}
        </Row>
      </Dropzone>
    </Tooltip>
    <Tooltip
      title={`Use this toggle when uploading files that contain static casts.
        To better detect static casts some of the checks that are run on dynamic casts are removed and could cause casts to not be detected correctly.`}
      enterDelay={700}
      leaveDelay={200}
    >
      <FormControlLabel
        control={
          <Switch
            checked={props.hasStaticCasts}
            onChange={(event, checked) =>
              props.actions.toggleHasStaticCasts(checked)
            }
            name="StaticCastsToggle"
          />
        }
        label="Detect casts via time gaps (recommended for static casts)"
        labelPlacement="start"
      />
    </Tooltip>
  </Card>
);

FileDropCard.propTypes = {
  actions: PropTypes.shape({
    toggleHasStaticCasts: PropTypes.func.isRequired
  }).isRequired,
  hasStaticCasts: PropTypes.bool.isRequired,
  onFilesDrop: PropTypes.func.isRequired,
  filesUploading: PropTypes.bool.isRequired
};

export default FileDropCard;
